import { Heading, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import React from "react";

const Card = ({ title, description, imageSrc }) => {
  return (
    <VStack backgroundColor={"white"} textColor={"black"} rounded="md">
      <Image src={imageSrc} />
      <VStack p={6}>
        <Heading alignSelf={"start"} size={"md"}>{title}</Heading>
        <Text textColor={"blackAlpha.600"}>{description}</Text>
        <HStack alignSelf={"start"}>
          <Text>See More</Text>
          <FontAwesomeIcon icon={faArrowRight} size="1x" />
        </HStack>
      </VStack>
    </VStack>
  );
};

export default Card;
